import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

import CategoriesDesktop from './CategoriesDesktop';
import AllProducts from './AllProducts';

const styles = {
  nav: {
    paddingHorizontal: 'medium'
  }
};

function SlideDesktop(props) {
  const {
    Group: { Nav }
  } = UX2;
  const { onClick, isSearch, routePath, selectedTaxonPermalink } = props;

  const allProductsInfo = OlsConfigStore.getAllProductsInfo() || {};
  const allProductsPosition = allProductsInfo?.position || 0;
  const allProducts = (
    <AllProducts
      allProductsInfo={ allProductsInfo }
      selectedTaxonPermalink={ selectedTaxonPermalink }
      isSearch={ isSearch }
      routePath={ routePath }
      onClick={ onClick }
      desktop={ true }
    />
  );

  const taxonList = CategoriesDesktop(props);
  taxonList.splice(allProductsPosition, 0, allProducts);

  return (
    <Nav.Vertical style={ styles.nav }>
      <UX2.Element.List>{ taxonList }</UX2.Element.List>
    </Nav.Vertical>
  );
}

SlideDesktop.propTypes = {
  taxons: PropTypes.array,
  routePath: PropTypes.string,
  isSearch: PropTypes.bool,
  selectedTaxonPermalink: PropTypes.string,
  onClick: PropTypes.func
};

export default SlideDesktop;
